/**
 * Returns the provided string with elements in brackets replaced by chip elements.
 *
 *
 * @param {String} providedString - String. (Mandatory) The string containing the elements you want to be replaced.
 * @param {Object} intl - Object. (Mandatory) The internalization object containing all the values translated.
 * @param {Array} landingPagesLinks - Array. (Optional) Array of landing pages to display the correct lpg name from Id (mandatory if clicked element is a LPG)
 *
 * @returns {String} New string with replaced elements.
 */

export default (providedString, intl, landingPagesLinks = []) => {
  const regex = /{([^}]*)}/gm; //EX.: {CONTENT}

  //replace a string like {CONTENT} with a Chip component, followed by a zero-width space the caret can stop on.
  return providedString.replaceAll(regex, (_, value) => {
    const splittedValue = value?.split('.')[1]?.toUpperCase() ?? '';
    const lpgValue = landingPagesLinks.find(
      ({ id }) => id?.toUpperCase() === splittedValue
    )?.name;

    const valueDisplayed = lpgValue ?? (intl.messages[splittedValue] || value);

    return `<span data-entity="${value}" class="chip" contenteditable="false"><span class="internal-span"><span class="chipText" data-translated="${valueDisplayed}"></span><span class="closeBtn" data-icon="&times;"></span></span></span>&#8203;`;
  });
};
